<div class="container">
    <mat-dialog-content class="content">
        <div class="div-message">
            <i class="material-icons size">info_outline</i>
            <span class="description">{{data.message}}</span>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="content">
        <button mat-button matDialogClose="cancel" class="btn-cancel">Ok</button>
    </mat-dialog-actions>
</div>